/**
 * Site Navigation
 */

import { trapFocus } from "./utils";

const navigation = document.getElementById('site-navigation');
const openButton = document.querySelector('[data-navigation-open]');
const closeButton = document.querySelector('[data-navigation-close]');
const dropdownOpenButtons = document.querySelectorAll('[data-dropdown-open');
const dropdownCloseButtons = document.querySelectorAll('[data-dropdown-close]');
if (!navigation) throw new Error('site-navigation element not found');

let returnFocusTarget = null;
let releaseSubmenuFocusTrap = null;


// ---------------------------------------------------------------------------
// Open / close
// ---------------------------------------------------------------------------

/** Open the mobile navigation drawer and save the return focus target. */
function open() {
    returnFocusTarget = document.activeElement;
    document.body.classList.add('site-navigation-open');
}

/** Close the mobile navigation drawer and restore focus. */
function close() {
    document.body.classList.remove('site-navigation-open');
    returnFocusTarget?.focus();
    returnFocusTarget = null;
}

// ---------------------------------------------------------------------------
// Event listeners
// ---------------------------------------------------------------------------

openButton.addEventListener('click', e => {
    e.preventDefault();
    open();
    return;
});

closeButton.addEventListener('click', e => {
    e.preventDefault();
    close();
    return;
});

dropdownOpenButtons?.forEach(button => {
    button.addEventListener('click', e => {
        e.preventDefault();
        returnFocusTarget = document.activeElement;
        button.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
        // on desktop, move focus to the drop down
        if (window.matchMedia('(min-width: 1025px)').matches) {
            button.closest('.primary-navigation__item').classList.add('active');
            const dropdown = button.nextElementSibling;
            if (dropdown) {
                releaseSubmenuFocusTrap = trapFocus(dropdown, true);
            }
        }
    });
});

dropdownCloseButtons?.forEach(button => {
    button.addEventListener('click', e => {
        e.preventDefault();
        dropdownOpenButtons?.forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-expanded', 'false');
        });
    })
});

// Escape key
document.addEventListener('keydown', e => {
    if ((e.key === 'Escape' || e.key === 'Esc')) {
        close();
        dropdownOpenButtons?.forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-expanded', 'false');
            el.closest('.primary-navigation__item').classList.remove('active');
        });
        releaseSubmenuFocusTrap?.();
        releaseSubmenuFocusTrap = null;
        returnFocusTarget?.focus();
        returnFocusTarget = null;
    }
});
